module.exports = __webpack_public_path__ + "img/shcs_cba.prt.5f1e3b07.jpg";